
export enum Manufacturer {
    "Better By Day" = 1,
    "Fake Lock For Testing" = 100
}
